import { Button, DatePicker, Input, Select } from 'antd';

import styles from './filter.module.scss';
import Icon from 'utils/icon';
import dayjs from 'dayjs';

function OrdersFilter() {
	const { RangePicker } = DatePicker;
	const nationalityOptions = [
		{ value: 'sa', label: 'Saudi' },
		{ value: 'eg', label: 'Egyptian' },
	];
	const statusOptions = [
		{ value: 'active', label: 'Active' },
		{ value: 'pending', label: 'Pending' },
		{ value: 'deleted', label: 'Deleted' },
	];

	const handleChange = (value: string) => {
		console.log(`Selected: ${value}`);
	};

	return (
		<div className={styles.filters}>
			<Input prefix={<Icon name="search" />} placeholder="Search" size="large" className="filled" />

			<div>
				<RangePicker
					size="large"
					maxDate={dayjs(new Date())}
					format="DD MMM YYYY"
					suffixIcon={<Icon name="calendar" />}
					separator="-"
					inputReadOnly
				/>

				<Select
					size="large"
					className="filled"
					placeholder="Nationality"
					optionFilterProp="label"
					onChange={handleChange}
					options={nationalityOptions}
				/>

				<Select
					size="large"
					className="filled"
					placeholder="Status"
					optionFilterProp="label"
					onChange={handleChange}
					options={statusOptions}
				/>

				<Button type="primary">Filter</Button>
			</div>
		</div>
	);
}

export default OrdersFilter;
